module.exports = __webpack_public_path__ + "static/media/29EUNOG18.92cedb20.jpg";